import { requestDataAccess } from './axios.js'
import { Buffer } from 'buffer'

export default function login (user, pwd) {
  const encodeString = Buffer.from(user + ':' + pwd).toString('base64')
  return requestDataAccess({
    headers: { Authorization: 'Basic ' + encodeString },
    url: '/users/name/' + user
  })
}
